if (!customElements.get('havelock-slideshow')) {
  customElements.define(
    'havelock-slideshow',
    class HavelockSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.blockSelectHandler = (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.show(selected, true);
        };
        document.addEventListener('shopify:block:select', this.blockSelectHandler);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      show(nextIndex, manual = false) {
        if (this.slides.length < 2) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (manual) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
